var _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgFuelShield = function SvgFuelShield(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 108,
    viewBox: "0 0 80 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.751 12.6009L41.8716 14.2818L71.0043 43.2079L71.005 63.6414C71.0059 90.3069 50.1639 91.8086 41.8742 89.2042C33.5844 83.099 12.7417 59.6993 12.7407 33.0337L12.7401 15.035L8.63281 14.7528L12.74 12.6065L12.74 12.6003L12.7507 12.6009L12.751 12.6007V12.6009Z",
    fill: "url(#paint0_linear_1511_13518)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1511_13518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5185 63.8328C63.5192 84.746 45.7975 89.6976 37.5911 87.7152C29.3846 81.0755 11.662 57.5041 11.6612 36.5909L11.6607 20.5669L37.5887 19.5274L63.5179 47.8088L63.5185 63.8328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7532 16.4223L8.62157 14.7408C8.62157 14.7408 8.62205 28.363 8.62229 35.1742C8.62322 61.8398 29.466 85.2395 37.7558 91.3447C46.0454 93.9491 66.8875 92.4474 66.8865 65.7818C66.8863 58.9707 66.8858 45.3484 66.8858 45.3484L37.7532 16.4223ZM60.4128 62.381C60.4135 83.2706 44.9253 85.7595 37.7555 84.319C30.5858 78.2267 15.0968 59.4646 15.0961 38.575L15.0955 22.5688L37.7534 23.8771L60.4122 46.3748L60.4128 62.381Z",
    fill: "url(#paint1_linear_1511_13518)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6367 49.4786L33.5537 61.9547L49.908 51.9586",
    stroke: "url(#paint2_linear_1511_13518)",
    strokeWidth: 4.56112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1511_13518",
    x1: 8.63281,
    y1: 2.28938,
    x2: 56.785,
    y2: 82.7836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141777,
    stopColor: "#9DDD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283782,
    stopColor: "#9DDD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293622,
    stopColor: "#64B82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57903,
    stopColor: "#59A922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710518,
    stopColor: "#509A1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720202,
    stopColor: "#3D7915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7915"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1511_13518",
    x1: 49.7185,
    y1: -1.98182,
    x2: 7.46376,
    y2: 53.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DDD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1511_13518",
    x1: 42.7572,
    y1: 42.0771,
    x2: 32.7233,
    y2: 57.1898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DDD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64B82A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1511_13518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.8998,
    height: 75.5544,
    fill: "white",
    transform: "matrix(0.88528 0.465059 3.49904e-05 1 8.15625 0.60791)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgFuelShield);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fuel-shield.aa451c12.svg";